import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './styles.module.scss';

const propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string
};

const FormWrapper = ({children, className = ''}) => <div className={classNames(styles['form-wrapper'], className)}>{children}</div>;

FormWrapper.propTypes = propTypes;

export default FormWrapper;
